query getFaceImage($uuid: String) {
    getFaceImage(uuid: $uuid) 
}
